(ns hypnos.consumer.db
  "Consumer database/state")

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; State

(def default-db
  {:app-name  "irisSleep"
   ;; Subdomain
   :subdomain nil
   ;; UI stuff
   :ui        {:active-panel {:name   :home-panel
                              :params nil}
               :loading?     false
               :loading-text nil}
   :error     nil
   ;; Current consult
   :consult   nil
   ;; Portrait
   :portrait  {:upload-status nil
               :file          nil
               :issues        []}})
